import { createReducer } from '@reduxjs/toolkit'
import { RewardState } from './type'
import { fetchRewardSuccess, setMyRewardsData, setRankingsData } from './actions'

const initialState: RewardState = {
  rewards: [],
  myRewards: [],
  rankings: [],
}

export default createReducer<RewardState>(initialState, (builder) =>
  builder
    .addCase(fetchRewardSuccess, (state, action) => {
      return {
        ...state,
        rewards: action?.payload,
      }
    })
    .addCase(setMyRewardsData, (state, action) => {
      return {
        ...state,
        myRewards: action?.payload,
      }
    })
    .addCase(setRankingsData, (state, action) => {
      return { ...state, rankings: action?.payload }
    }),
)
